import { QueryClient } from '@tanstack/react-query';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// Fonction utilitaire pour émettre les erreurs de sécurité
const emitSecurityError = (error, context) => {
    console.error(`🚨 [Keycloak] SecurityError (${context}):`, error.message);
    
    window.dispatchEvent(new CustomEvent('keycloakSecurityError', {
        detail: {
            errorName: error.name,
            errorMessage: error.message,
            context,
            timestamp: Date.now()
        }
    }));
};

// Fonction pour créer le UserManager avec gestion complète des erreurs
const createUserManager = () => {
    // Étape 1: Tenter de créer un store sécurisé
    let userStore = null;
    try {
        userStore = new WebStorageStateStore({ store: window.sessionStorage });
        // Test de fonctionnement
        sessionStorage.setItem('__test__', '1');
        sessionStorage.removeItem('__test__');
        console.log('✅ [Keycloak] Storage disponible');
    } catch (error) {
        if (error.name === 'SecurityError' || error.message.includes('insecure')) {
            emitSecurityError(error, 'WebStorageStateStore');
        }
        console.warn('⚠️ [Keycloak] Storage non disponible, mode sans persistance');
    }

    // Étape 2: Tenter de créer le UserManager
    const config = {
        authority: window.ENV.REACT_APP_KEYCLOAK_URL,
        client_id: window.ENV.REACT_APP_KEYCLOAK_CLIENT,
        redirect_uri: `${window.location.origin}${window.location.pathname}`,
        post_logout_redirect_uri: window.location.origin,
        userStore,
        monitorSession: false,
    };

    try {
        const manager = new UserManager(config);
        console.log('✅ [Keycloak] UserManager créé');
        return manager;
    } catch (error) {
        if (error.name === 'SecurityError' || error.message.includes('insecure')) {
            emitSecurityError(error, 'UserManager');
        }
        
        // Fallback: UserManager sans storage
        try {
            console.warn('⚠️ [Keycloak] Tentative sans storage');
            return new UserManager({ ...config, userStore: undefined });
        } catch (fallbackError) {
            console.error('❌ [Keycloak] UserManager impossible à créer');
            // Mock minimal pour éviter les crashes
            return {
                signinRedirect: () => Promise.reject(new Error('UserManager non disponible')),
                signoutRedirect: () => Promise.reject(new Error('UserManager non disponible')),
                getUser: () => Promise.resolve(null),
            };
        }
    }
};

export const userManager = createUserManager();

export const onSigninCallback = () => {
    window.history.replaceState({}, document.title, window.location.pathname);
};

export const queryClient = new QueryClient();
